import { defineMessages } from 'react-intl';

export default defineMessages({
    saveTrusteeDetails: {
        id: 'components.e1pEHTPITrusteeDetailsComponent.SAVE TRUSTEE DETAILS',
        defaultMessage: 'SAVE TRUSTEE DETAILS'
    },
});
